import actions from '../../actionTypes';

export default (errorPayload, source) => {
  if (source) {
    errorPayload.source = source;
  }
  return {
    type: actions.SEND_ERROR_REPORT,
    errorPayload
  };
};


// WEBPACK FOOTER //
// ./src/reducers/report/actions/reportError.js